import React, { useState, useRef } from "react";

export default function MarkDonePopup({eleRef}) {

    console.log('-----------------eleRef', eleRef);

    let vaccineId = eleRef.state.selectedVaccineId;
    let vaccArr = eleRef.state.vaccineData;

    const childDOB = (() => {
        const dob = new Date(eleRef.state.selectedChild.DOB);

        const year = dob.getFullYear();
        const month = String(dob.getMonth() + 1).padStart(2, "0");
        const day = String(dob.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    })();

    console.log('-------------dob', childDOB);

    const vaccineDetails = vaccArr.find(
        v => v.vaccineid == vaccineId
    );

    console.log(vaccineDetails);

    const errorTimer = useRef(null);
    const fieldErrorTimers = useRef({});
    const dateRef = useRef(null);
    const [openHeight, setOpenHeight] = useState(false);
    const [open, setOpen] = useState(false);
    const options = ["cm", "in"];

    // Local calendar date (YYYY-MM-DD); toISOString() returns the UTC date and can be off by a day
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);

        return date.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric"
        });
    };

    const [error, setError] = useState("");
    const [formData, setFormData] = useState({
        date: getTodayDate(),
        weight: "",
        height: "",
        hc: "",
        heightUnit:"cm",
        hcUnit:"cm"
    });

    const [fieldErrors, setFieldErrors] = useState({
        weight: { msg: "", visible: false },
        height: { msg: "", visible: false },
        hc: { msg: "", visible: false }
    });

    const showError = (msg) => {
        setError(msg);

        if (errorTimer.current) {
            clearTimeout(errorTimer.current);
        }

        errorTimer.current = setTimeout(() => {
            setError("");
        }, 2000);
    };

    const handleChange = (e) => {
        console.log('---------------------vaccination');
        const { name, value } = e.target;

        let errors = { ...fieldErrors };

        const numericFields = ["weight", "height", "hc"];

        // ✅ Apply validation only for numeric fields
        if (numericFields.includes(name) && /[^0-9.]/.test(value)) {

            if (name === "weight") errors.weight = { msg: "Weight between 1–100", visible: true };
            if (name === "height") errors.height = { msg: "Height between 1 to 1000", visible: true };
            if (name === "hc") errors.hc = { msg: "Head circumference between 1 to 1000", visible: true };

            setFieldErrors(errors);

            setTimeout(() => {
                setFieldErrors(prev => ({
                    ...prev,
                    [name]: { ...prev[name], visible: false }
                }));
            }, 1000);

            setTimeout(() => {
                setFieldErrors(prev => ({
                    ...prev,
                    [name]: { msg: "", visible: false }
                }));
            }, 1400);

            return;
        }

        // ✅ Range validation only for numeric fields
        if (numericFields.includes(name)) {


            if (value === "0") {

                if (name === "weight") {
                    errors.weight = { msg: "Weight cannot be 0", visible: true };
                }

                if (name === "height") {
                    errors.height = { msg: "Height cannot be 0", visible: true };
                }

                if (name === "hc") {
                    errors.hc = { msg: "Head circumference cannot be 0", visible: true };
                }

                setFieldErrors(errors);

                return;
            }


            const numericValue = parseFloat(value);

            if (name === "weight" && numericValue > 100) {
                errors.weight = { msg: "Weight between 1–100", visible: true };
                setFieldErrors(errors);

                setTimeout(() => {
                    setFieldErrors(prev => ({
                        ...prev,
                        [name]: { ...prev[name], visible: false }
                    }));
                }, 1000);
                return;
            }

            if (name === "height" && numericValue > 1000) {
                errors.height = { msg: "Height between 1 to 1000", visible: true };
                setFieldErrors(errors);
                setTimeout(() => {
                    setFieldErrors(prev => ({
                        ...prev,
                        [name]: { ...prev[name], visible: false }
                    }));
                }, 1000);
                return;
            }

            if (name === "hc" && numericValue > 1000) {
                errors.hc = { msg: "Head circumference between 1 to 1000", visible: true };
                setFieldErrors(errors);
                setTimeout(() => {
                    setFieldErrors(prev => ({
                        ...prev,
                        [name]: { ...prev[name], visible: false }
                    }));
                }, 1000);
                return;
            }
        }

        // ✅ Update formData for ALL fields (including select)
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setFieldErrors(errors);
        setError("");
    };

    const handleSelect = (value) => {
        setFormData({
        ...formData,
        hcUnit: value
        });
        setOpen(false);
    };

    const handleSave = () => {
        if (!formData.date) {
            showError("Please select date");
            return;
        }

        if (formData.date > getTodayDate()) {
            showError("Future dates are not allowed");
            return;
        }

        setError("");
        eleRef.addVaccineDetails(formData);
    };

    const capitalize = (str) =>
        str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

    const toggleUnit = (valueKey, unitKey) => {
        const isCm = formData[unitKey] === "cm";
        const value = parseFloat(formData[valueKey]);

        setFormData(prev => ({
            ...prev,
            [unitKey]: isCm ? "in" : "cm",
            [valueKey]:
                prev[valueKey] === ""
                    ? ""
                    : Number(
                        (
                            isCm
                                ? value / 2.54
                                : value * 2.54
                        ).toFixed(1)
                    ),
        }));
    };


    return (
        <div className="markDone-overlay">
            <div className="markDonemodal">
                <div className="closeMarkDoneBtn" onClick={eleRef.closeMarkDone} >
                    <img className="closeBtnImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/closeBtn.png"></img>
                </div>
                <div className="markdoneForm">

                    <div className="modal-title">
                        {/* <img className="titleVaccineImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/vaccine.png" alt="vaccine_img"></img> */}
                         <svg width="34" height="34" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1817_121)">
                            <path d="M5.86419 18.9361C6.04576 18.7546 6.29181 18.6523 6.54851 18.6523C6.80537 18.6523 7.0519 18.7552 7.23352 18.9368L8.37428 20.0776L19.7971 8.65474C20.1708 8.32382 20.634 8.11086 21.1284 8.04293C21.6681 7.99034 22.2128 8.07023 22.7146 8.27564C22.9686 8.37963 23.2078 8.51466 23.4272 8.67615L24.4354 7.66797C24.6148 7.51079 24.8242 7.39143 25.0507 7.31648C25.2772 7.24153 25.5165 7.21239 25.7543 7.23155C25.9921 7.25071 26.2236 7.31747 26.4352 7.42766C26.547 7.48591 26.6514 7.55689 26.748 7.63689L31.0645 3.32036C31.1856 3.19935 31.3498 3.1305 31.521 3.13047C31.6922 3.13047 31.8564 3.19932 31.9774 3.32036C32.0983 3.44135 32.1666 3.60509 32.1666 3.77612C32.1666 3.94729 32.0985 4.11221 31.9774 4.23325L27.6616 8.54909L27.8936 8.78111C28.1913 9.10815 28.3722 9.52687 28.4046 9.97159C28.4113 10.2033 28.3691 10.4342 28.2803 10.6483C28.1916 10.8622 28.0586 11.055 27.8902 11.2139L26.8723 12.2317C27.1593 12.7037 27.3445 13.2359 27.4082 13.7937C27.4171 14.1245 27.3566 14.4537 27.2307 14.7597C27.1047 15.0659 26.9162 15.3417 26.6769 15.5704L15.272 26.9753L16.283 27.9862C16.3728 28.0762 16.445 28.1829 16.4936 28.3004C16.5421 28.4178 16.5668 28.5436 16.5668 28.6706C16.5667 28.7977 16.5416 28.924 16.4929 29.0414C16.4442 29.1588 16.3722 29.2657 16.2823 29.3556C16.1009 29.5368 15.8551 29.6385 15.5987 29.6387C15.342 29.6388 15.0952 29.5369 14.9136 29.3556L12.3697 26.8116C12.3433 26.8382 12.3189 26.8666 12.291 26.8917L12.2931 26.8938L9.20569 29.9812L10.1082 30.8837C10.1982 30.9737 10.2702 31.0804 10.3188 31.1979C10.3674 31.3152 10.392 31.4411 10.392 31.568C10.392 31.6952 10.3668 31.8214 10.3181 31.9389C10.2694 32.0563 10.1982 32.1639 10.1082 32.2537C9.92668 32.4351 9.67985 32.5369 9.42321 32.5369C9.16658 32.5368 8.92036 32.4345 8.73889 32.253L3.15316 26.6673C2.9717 26.4858 2.86945 26.2397 2.86935 25.983C2.86935 25.7261 2.97153 25.4789 3.15316 25.2973C3.33476 25.1158 3.58141 25.0142 3.83817 25.0142C4.09493 25.0142 4.3409 25.1165 4.52249 25.298L5.57831 26.3538L8.67605 23.2561C8.69996 23.2337 8.72658 23.2146 8.75132 23.1932L5.86419 20.3061C5.68261 20.1245 5.57973 19.8779 5.57969 19.6211C5.57969 19.3643 5.68257 19.1177 5.86419 18.9361ZM13.9034 25.6067L25.3082 14.2018C25.3599 14.1601 25.4012 14.107 25.4298 14.0471C25.4583 13.9871 25.4735 13.9209 25.4733 13.8545C25.3803 13.4366 25.1549 13.06 24.8311 12.78L22.638 10.5869C22.4955 10.4084 22.3187 10.26 22.118 10.1511C21.9171 10.0423 21.6956 9.97492 21.4682 9.95294C21.3444 9.95928 21.2247 9.99988 21.1222 10.0696L19.5906 11.6012L21.3121 13.3227C21.4021 13.4126 21.474 13.5195 21.5227 13.6369C21.5713 13.7542 21.5959 13.8801 21.5959 14.0071C21.5959 14.1343 21.5714 14.2611 21.5227 14.3786C21.474 14.4961 21.4021 14.6029 21.3121 14.6928C21.2222 14.7827 21.1148 14.854 20.9972 14.9027C20.8799 14.9512 20.7541 14.9759 20.6271 14.9759C20.4999 14.9758 20.3738 14.9507 20.2563 14.902C20.139 14.8533 20.0326 14.7819 19.9428 14.6921L18.2213 12.9706L16.1366 15.0553L17.8581 16.7768C17.9481 16.8667 18.02 16.9735 18.0687 17.091C18.1173 17.2083 18.1418 17.3341 18.1419 17.4611C18.1419 17.5884 18.1174 17.7151 18.0687 17.8326C18.02 17.9501 17.9481 18.0569 17.8581 18.1468C17.7682 18.2366 17.6613 18.3074 17.5439 18.3561C17.4264 18.4047 17.3003 18.43 17.1731 18.4299C17.0459 18.4299 16.9197 18.4048 16.8023 18.3561C16.685 18.3073 16.5785 18.236 16.4887 18.1461L14.7672 16.4246L12.6832 18.5087L14.4047 20.2302C14.4947 20.3201 14.5666 20.4269 14.6153 20.5444C14.6639 20.6617 14.6885 20.7875 14.6885 20.9145C14.6885 21.0417 14.6641 21.1684 14.6153 21.286C14.5666 21.4035 14.4947 21.5103 14.4047 21.6002C14.3148 21.69 14.2079 21.7608 14.0905 21.8094C13.973 21.8581 13.8469 21.8833 13.7197 21.8833C13.5926 21.8832 13.4663 21.8581 13.3489 21.8094C13.2316 21.7607 13.1251 21.6893 13.0354 21.5995L11.3139 19.878L9.7443 21.4476L13.9034 25.6067ZM7.83567 28.6112L10.923 25.5238C10.9494 25.4978 10.9748 25.4701 10.9976 25.4409L10.1338 24.5771C10.0926 24.5969 10.0534 24.6216 10.0178 24.6503L6.94626 27.7218L7.83567 28.6112ZM25.5755 10.7885L26.3689 9.99507L25.6086 9.23479L24.8152 10.0282C25.1238 10.3367 25.3694 10.5829 25.5755 10.7885Z" fill="#616161"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_1817_121">
                            <rect width="36" height="36" fill="#757575"/>
                            </clipPath>
                            </defs>
                        </svg>
                        <span className="titleVaccineText" >{vaccineDetails.vaccinetitle}-{vaccineDetails.dosetitle}</span>
                    </div>
                    <div className="vaccineBox_div">
                        <div className="addVaccineBox">
                            <div className="input_box">
                                <div className="inputlabel labelvccine">
                                    <span>Date<sup className="error">*</sup></span>
                                </div>
                                <div className="input-with-icon vaccineDate" onClick={() => dateRef.current?.showPicker?.()}>
                                        <div className="datecontainer">
                                            {/* <input ref={dateRef}
                                                type="date"
                                                value={formData.date}
                                                max={getTodayDate()}
                                                min={childDOB}
                                                onChange={(e) => {
                                                    const selectedDate = e.target.value;

                                                    // iOS WebView picker can emit dates beyond max
                                                    if (selectedDate > getTodayDate()) {
                                                        showError("Future dates are not allowed");
                                                        return;
                                                    }

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        date: selectedDate
                                                    }));
                                                }}
                                                style={{ position: "absolute", opacity: 0 }} // hide actual input
                                            /> */}

                                            
                                            <input
                                                ref={dateRef}
                                                type="date"
                                                name="date"
                                                value={formData.date}
                                                max={getTodayDate()}
                                                min={childDOB}
                                                onChange={(e) => {
                                                    const selectedDate = e.target.value;
                                                    const today = getTodayDate();

                                                    // Prevent future dates on iOS and other browsers
                                                    if (selectedDate && selectedDate > today) {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            date: today
                                                        }));

                                                        showError("Future dates are not allowed");
                                                        return;
                                                    }

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        date: selectedDate
                                                    }));

                                                    setError("");
                                                }}
                                                style={{ position: "absolute", opacity: 0,}}
                                            />






                                            <span className="date_text">
                                                {formatDate(formData.date)}
                                            </span>
                                        </div>
                                    <span className="date_icon_vaccine">
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_calender.svg" />
                                    </span>
                                </div>
                            </div>

                            {/* Weight */}
                            <div className="input_box">
                                <div className="inputlabel labelvccine">
                                    <span>Weight</span>
                                </div>
                                <div className="input-with-unit">
                                    <div className="inputcontainer">
                                        <input className="R16_21" name="weight" value={formData.weight} onChange={handleChange}  autoComplete="off" />
                                    </div>
                                    <span className="unit_label">Kg</span>
                                </div>
                                {fieldErrors.weight.msg && (
                                    <div className={`field-error ${fieldErrors.weight.visible ? "show" : "hide"}`}>
                                        {fieldErrors.weight.msg}
                                    </div>
                                )}
                            </div>
                            
                            {/* Height */}
                            <div className="input_box">
                                <div className="inputlabel labelvccine">
                                    <span>Height</span>
                                </div>
                                <div className="input-with-unit">
                                    <div className="inputcontainer">
                                        <input className="R16_21" name="height" value={formData.height} onChange={handleChange} autoComplete="off" />
                                    </div>
                                    <div className="custom-select">

                                        <div className="selected" onClick={() => toggleUnit("height", "heightUnit")}>
                                           <span> {capitalize(formData.heightUnit)} </span>
                                            <span className={`arrow ${formData.heightUnit === "in" ? "rotate" : ""}`}>
                                                <img
                                                    src="https://cdn.cdnparenting.com/articles/babynameimages/ic-dropdown.svg"
                                                    alt=""
                                                />
                                            </span>
                                        </div>

                                    
                                    </div>
                                </div>
                                {fieldErrors.height.msg && (
                                    <div className={`field-error ${fieldErrors.height.visible ? "show" : "hide"}`}>
                                        {fieldErrors.height.msg}
                                    </div>
                                )}
                            </div>

                            <div className="input_box">
                                <div className="inputlabel labelvccine">
                                    <span>Head Circ.</span>
                                </div>
                                <div className="input-with-unit">
                                    <div className="inputcontainer">
                                        <input className="R16_21" autoComplete="off" name="hc" value={formData.hc} onChange={handleChange} />
                                    </div>

                                    <div className="selected" onClick={() => toggleUnit("hc", "hcUnit")}>
                                            {capitalize(formData.hcUnit)}
                                            <span className={`arrow ${formData.hcUnit === "in" ? "rotate" : ""}`}>
                                                <img
                                                    src="https://cdn.cdnparenting.com/articles/babynameimages/ic-dropdown.svg"
                                                    alt=""
                                                />
                                            </span>
                                        
                                    </div>

                                </div>
                                {fieldErrors.hc.msg && (
                                    <div className={`field-error ${fieldErrors.hc.visible ? "show" : "hide"}`}>
                                        {fieldErrors.hc.msg}
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                    {error && (
                        <div className="form-error">
                            {error}
                        </div>
                    )}
                    {/* Buttons */}
                    <div className="modal-actions-vcc">
                        <div className="btn-cancel"  onClick={eleRef.closeMarkDone} >
                            Cancel
                        </div>
                        <div className="btn-save M16_white"  onClick={handleSave}>
                            Save
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}